/* eslint-disable no-undef */
import isArray from 'lodash-es/isArray'
import isString from 'lodash-es/isString'

// URL cache to avoid redundant calculations
const urlCache = {}

// Detect mobile once and reuse
let isMobile = false
let isMobileLandscape = false

// Set up mobile detection only on client
if (typeof window !== 'undefined') {
  // Set this once at module level for initial render
  isMobile = window.innerWidth < 360
  isMobileLandscape = window.innerWidth >= 360 && window.innerWidth < 640

  // Update on resize with debouncing
  let resizeTimeout
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
      const width = window.innerWidth
      isMobile = width < 360
      isMobileLandscape = width >= 360 && width < 640
    }, 200)
  })
}

export function getS3Url(url, variant = 'public', video = false) {
  // Return early if no URL
  if (!url || (!isArray(url) && !isString(url))) {
    return
  }

  // For server-side rendering, use largest image
  const isServerSide = typeof window === 'undefined'

  // Use server defaults or client detection
  const effectiveIsMobile = isServerSide ? false : isMobile
  const effectiveIsMobileLandscape = isServerSide ? false : isMobileLandscape

  // Generate a cache key
  const cacheKey = `${url}-${variant}-${video}-${effectiveIsMobile}-${effectiveIsMobileLandscape}`

  // Return cached URL if available
  if (urlCache[cacheKey]) {
    return urlCache[cacheKey]
  }

  let result

  // Determine which type of URL this is
  if (url.includes('images/') || url.includes('videos/')) {
    result = process.env.NEXT_PUBLIC_ASSETS_URL + url.replaceAll(' ', '%20')
  } else if (video) {
    result = `https://customer-${process.env.NEXT_PUBLIC_CLOUDFLARE_CUSTOMER}.cloudflarestream.com/${url}/manifest/video.m3u8`
  } else {
    // Determine the cloudflare variant to use
    let cloudflareVariant

    // Server-side: Prioritize provided variant if it exists, otherwise use largest
    if (isServerSide) {
      cloudflareVariant =
        variant && variant !== 'public' && variant !== ''
          ? variant // Use provided variant if it exists and is not 'public' or empty
          : '1980' // Otherwise use largest variant for server-side
    } else {
      // Client-side: Use existing responsive logic
      cloudflareVariant = effectiveIsMobile
        ? 360
        : effectiveIsMobileLandscape
        ? 640
        : variant === 'public' || variant === '' || !variant
        ? 960
        : variant
    }

    result = `https://imagedelivery.net/${process.env.NEXT_PUBLIC_CLOUDFLARE_IMAGES_ACCOUNT}/${url}/${cloudflareVariant}`
  }

  // Cache the result
  urlCache[cacheKey] = result

  return result
}
